import PlaybookModal from '../PlaybookModal'
import { Creatable as UISelect } from 'components/shared/UISelect'
import LoadingDots from 'components/shared/LoadingDots'
import Toggle from 'components/Toggle'

import style from './style.styl'

const AttributeCreatePendingLabel = ({
  selectedFieldAttribute
}) => (
  <div>
    <span>{selectedFieldAttribute}</span>
    <span className="playbook-question-advanced-attribute-create-loading">(creating <LoadingDots />)</span>
  </div>
)

const QuestionAdvancedModal = ({
  onCloseClick,
  FieldAttributes,
  selectedFieldAttribute,
  onSelectFieldAttribute,
  onNewOptionClick,
  isSelectedAttributeCreatePending,
  buttonOnlyResponses,
  onToggleButtonOnlyResponse,
  questionHasKeywordAnswers,
  numKeywordsInQuestion,
  confirmKeywordsDelete,
  setConfirmKeywordsDelete,
  onDeleteAllKeywordResponses,
  onFirstDeleteKeywordClick,
}) => {
  const userPropertiesOptions = FieldAttributes.filter(
    attr => attr.value[0] !== '_' || attr.value === selectedFieldAttribute
  )
  !!selectedFieldAttribute && // show custom tag if recently created...
    userPropertiesOptions.unshift({
      label: isSelectedAttributeCreatePending ? <AttributeCreatePendingLabel selectedFieldAttribute={selectedFieldAttribute} /> : selectedFieldAttribute,
      value: selectedFieldAttribute })
  userPropertiesOptions.unshift({ label: 'No Mapping', value: undefined })
  return (
    <PlaybookModal
      onCloseClick={onCloseClick}
      title="Advanced Settings"
      hideDescription
      contentClassName={style.QuestionAdvancedModal}
    >
      <div className="playbook-question-advanced-modal-heading">
        <div>
          <strong>Map Customer Response to Drift Attribute (Optional)</strong>
          <p>
            Drift can add this response to a new or existing attribute on the User’s Profile. This
            is helpful for creating segments, and syncing to your integrations.{' '}
            <a
              className="link"
              href="https://help.drift.com/playbooks/attribute-mapping-in-playbooks"
              target="_blank"
            >
              Learn More.
            </a>
          </p>
          <p className="helptext">
            The property will be converted into lowercase and spaces replaced with underscores. Like
            "<code>zip_code</code>".
          </p>
        </div>
        <UISelect
          clearable={true}
          className="attribute-select"
          options={userPropertiesOptions}
          value={selectedFieldAttribute}
          onChange={onSelectFieldAttribute}
          onNewOptionClick={onNewOptionClick}
        />
      </div>
      <div className="playbook-question-advanced-modal-buttons-only-section">
        <div className="playbook-question-advanced-button-label">
          <strong>Limit Customer Response To Buttons Only</strong>
          {questionHasKeywordAnswers &&
            <div>
              <p className="playbook-question-advanced-button-disabled">Remove keyword answers to enable</p>
              {!confirmKeywordsDelete ?
                <p className="playbook-question-advanced-button-disabled">
                  <span className="link" onClick={onFirstDeleteKeywordClick}>Click here</span>{' '}
                  to delete all keywords on this question
                </p>
                :
                <p className="playbook-question-advanced-button-disabled">
                  Are you sure you want to delete {numKeywordsInQuestion} keywords?{' '}
                  <span className="playbook-question-advanced-button-confirm">
                    <span className="link" onClick={onDeleteAllKeywordResponses}>Yes</span>|
                    <span className="link" onClick={() => setConfirmKeywordsDelete(false)}>No</span>
                  </span>
                </p>
              }
            </div>
          }
          <p>When this feature is on, the text input on the chat widget will be disabled and end users will be encouraged to select one of the available button responses from the bot</p>
        </div>
        <div className="playbook-question-advanced-button-input">
          <Toggle
            disabled={questionHasKeywordAnswers}
            onChange={onToggleButtonOnlyResponse}
            className="playbook-toggle"
            checked={buttonOnlyResponses || false}
            icons={{
              checked: <span>On</span>,
              unchecked: <span>Off</span>,
            }}
          />
        </div>
      </div>
    </PlaybookModal>
  )
}

export default QuestionAdvancedModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/QuestionAdvancedModal/component.js